"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = void 0;
var pill_1 = require("./pill");
Object.defineProperty(exports, "Pill", { enumerable: true, get: function () { return pill_1.Pill; } });
//# sourceMappingURL=index.js.map